module.exports = __webpack_public_path__ + "img/kefu.d8ad9690.svg";